import { cn } from '@brew/ui/cn'

export type MaskedLogoProps = {
  src: string
  alt: string
  width: number
  height: number
  className?: string
}

/**
 * Renders a monochrome logo silhouette using CSS `mask-image`, so the logo
 * color comes from `currentColor` on the parent. This is the right tool for
 * logo strips where the source SVGs hard-code a single fill (e.g. white) and
 * we want them to adapt to the surrounding text color (light vs dark mode,
 * muted-foreground, etc.).
 */
export function MaskedLogo({
  src,
  alt,
  width,
  height,
  className,
}: MaskedLogoProps) {
  const maskImage = `url(${src})`
  return (
    <span
      role="img"
      aria-label={alt}
      className={cn('block bg-current', className)}
      style={{
        width,
        height,
        maxWidth: '100%',
        maxHeight: '100%',
        WebkitMaskImage: maskImage,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
      }}
    />
  )
}
